import React from 'react';

export default function SvgRecordingIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" {...props}>
            <path
                d="M2.5 8.5H2C1.73478 8.5 1.48043 8.39464 1.29289 8.20711C1.10536 8.01957 1 7.76522 1 7.5V2.5C1 2.23478 1.10536 1.98043 1.29289 1.79289C1.48043 1.60536 1.73478 1.5 2 1.5H10C10.2652 1.5 10.5196 1.60536 10.7071 1.79289C10.8946 1.98043 11 2.23478 11 2.5V7.5C11 7.76522 10.8946 8.01957 10.7071 8.20711C10.5196 8.39464 10.2652 8.5 10 8.5H9.5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 7.5L8.5 10.5H3.5L6 7.5Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
